// src/features/resources/services/folderService.js
import {
  collection,
  addDoc,
  getDocs,
  query,
  orderBy,
  where,
  doc,
  getDoc,
  updateDoc,
  deleteDoc,
  serverTimestamp
} from "firebase/firestore";
import { db } from "../firebase/config";

/**
 * Folder model:
 * {
 *   name: string,
 *   visibility: "public" | "institutional" | "private",
 *   ownerId: string,
 *   institutionId: string | null,
 *   createdAt: timestamp
 * }
 */

const foldersCollection = collection(db, "folders");

export const createFolder = async (folder) => {
  const docRef = await addDoc(foldersCollection, {
    ...folder,
    createdAt: serverTimestamp()
  });
  return { id: docRef.id, ...folder };
};

export const fetchFoldersForUser = async (userProfile) => {
  // Fetch public folders + user's private + institutional where applicable
  const q = query(foldersCollection, orderBy("createdAt", "desc"));
  const snapshot = await getDocs(q);
  const folders = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));

  // Filter client-side to enforce institution visibility for display if needed.
  // The rules server-side will enforce access.
  return folders;
};

export const fetchFolderById = async (folderId) => {
  const d = await getDoc(doc(db, "folders", folderId));
  return d.exists() ? { id: d.id, ...d.data() } : null;
};

export const updateFolder = async (folderId, updates) => {
  await updateDoc(doc(db, "folders", folderId), updates);
};

export const deleteFolder = async (folderId) => {
  await deleteDoc(doc(db, "folders", folderId));
};
